module.exports = __webpack_public_path__ + "static/tlc-issues-b6bd0204b3ec408c3edd387ec7f80f06.jpg";